/** BanyanPro embed / postMessage configuration (Vite env). */

export type LmsLaunchMode = 'query' | 'postmessage' | 'auto';

const DEFAULT_DEV_ORIGINS = ['http://localhost:5173', 'http://localhost:3000', 'http://127.0.0.1:5173'];

function parseCommaSeparatedOrigins(raw: string | undefined): string[] {
  if (!raw || !raw.trim()) {
    return [];
  }
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((origin) => {
      try {
        return new URL(origin).origin;
      } catch {
        return origin.replace(/\/$/, '');
      }
    })
    .filter((origin) => origin !== '*');
}

export function getBanyanproEmbedEnabled(): boolean {
  const v = import.meta.env.VITE_BANYANPRO_EMBED_ENABLED;
  if (v === undefined || v === '') {
    return import.meta.env.DEV;
  }
  return String(v).toLowerCase() === 'true' || v === '1';
}

export function getLmsLaunchMode(): LmsLaunchMode {
  const raw = (import.meta.env.VITE_LMS_LAUNCH_MODE ?? 'auto').toString().toLowerCase();
  if (raw === 'query' || raw === 'postmessage' || raw === 'auto') {
    return raw;
  }
  return 'auto';
}

/** Exact-match parent origins allowed to send BANYANPRO_ASSERTION. */
export function getAllowedParentOrigins(): string[] {
  const configured = parseCommaSeparatedOrigins(import.meta.env.VITE_BANYANPRO_ALLOWED_PARENT_ORIGINS);
  if (configured.length > 0) {
    return [...new Set(configured)];
  }
  if (import.meta.env.DEV) {
    return [...new Set(DEFAULT_DEV_ORIGINS)];
  }
  return [];
}

/** Milliseconds to wait for parent assertion after TKM_EMBED_READY. */
export function getEmbedAssertionTimeoutMs(): number {
  const raw = import.meta.env.VITE_BANYANPRO_EMBED_TIMEOUT_MS;
  const n = raw ? Number(raw) : 60_000;
  return Number.isFinite(n) && n > 0 ? n : 60_000;
}

export function isEmbedPostMessageMode(): boolean {
  const mode = getLmsLaunchMode();
  if (mode === 'postmessage') {
    return true;
  }
  if (mode === 'query') {
    return false;
  }
  return getBanyanproEmbedEnabled();
}
